// --- START OF FILE public/js/firebase/config.js ---

/**
 * Configurazione e inizializzazione di Firebase (Sintassi Modulare v1.14 - Final Safari & Analytics Fix)
 * MODIFICATO: Ripristinata la logica di rilevamento robusta di Safari per disabilitare
 *             la persistenza SOLO su quel browser, risolvendo un bug su Chrome Mobile.
 * MANTIENE: Inizializzazione di Firebase Analytics e logica di persistenza moderna.
 */

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, initializeFirestore, persistentLocalCache, CACHE_SIZE_UNLIMITED } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

// Configurazione di Firebase (invariata)
const firebaseConfig = {
  apiKey: "AIzaSyDMoGUjA2cRu5aNTJLi7t6VDjzeEWluoRo",
  authDomain: "pac-maldini.firebaseapp.com",
  projectId: "pac-maldini",
  storageBucket: "pac-maldini.firebasestorage.app",
  messagingSenderId: "667993776070",
  appId: "1:667993776070:web:2733fb593d6913c260dcc7",
  measurementId: "G-HLYZ1083GF"
};

const firebaseApp = initializeApp(firebaseConfig);
const authService = getAuth(firebaseApp);
const analytics = getAnalytics(firebaseApp);
console.log("[Firebase Config v1.14] Firebase App e Analytics inizializzati.");

let dbService;
let internalPersistencePromise;

// --- INIZIO LOGICA DI RILEVAMENTO SAFARI (ROBUSTA) ---
/**
 * Rileva in modo affidabile se il browser è Safari, escludendo altri
 * browser basati su WebKit come Chrome, Edge, etc.
 * @returns {boolean} True se è Safari, altrimenti false.
 */
function isTrulySafari() {
    const ua = navigator.userAgent;
    // La condizione più affidabile è verificare la presenza di 'Safari'
    // e l'assenza di altri identificativi di browser comuni.
    return /Safari/i.test(ua) &&          // Deve contenere "Safari"
           !/Chrome/i.test(ua) &&         // NON deve essere Chrome
           !/CriOS/i.test(ua) &&          // NON deve essere Chrome su iOS
           !/FxiOS/i.test(ua) &&          // NON deve essere Firefox su iOS
           !/Edg/i.test(ua);              // NON deve essere Edge
}
// --- FINE LOGICA DI RILEVAMENTO SAFARI ---

const isSafariDetected = isTrulySafari();

// Imposta i flag globali che verranno letti dalle scene
window.firestorePersistenceSkipped = false;
window.persistenceSkipReason = "";

if (isSafariDetected) {
    window.firestorePersistenceSkipped = true;
    window.persistenceSkipReason = "safari_detected";
    console.warn("[Firebase Config] Rilevato Safari. La persistenza offline di Firestore sarà disabilitata.");
}

// Condizione modificata per usare la nuova funzione di rilevamento
if (window.IS_GAME_PAGE === true && !isSafariDetected) {
    console.log("[Firebase Config] Pagina di gioco rilevata (non Safari). Tentativo inizializzazione Firestore con persistenza...");
    internalPersistencePromise = new Promise((resolve) => {
        try {
            dbService = initializeFirestore(firebaseApp, {
                localCache: persistentLocalCache({
                    synchronizeTabs: true,
                    cacheSizeBytes: CACHE_SIZE_UNLIMITED
                })
            });
            console.log("[Firebase Config] Firestore inizializzato con persistenza locale moderna abilitata.");
            resolve({ success: true, reason: "persistence_enabled" });
        } catch (initError) {
            window.firestorePersistenceSkipped = true;
            window.persistenceSkipReason = initError.code || "firestore_init_error_modern";
            console.warn(`[Firebase Config] Errore durante initializeFirestore con persistenza (Codice: ${window.persistenceSkipReason}). Fallback a Firestore solo online.`);
            dbService = getFirestore(firebaseApp);
            resolve({ success: false, error: initError, reason: "persistence_failed_fallback_online" });
        }
    });
} else {
    // Questo blocco ora gestisce sia la landing page che il gioco su Safari.
    const reason = isSafariDetected ? "Safari rilevato" : "Non è la pagina di gioco";
    console.log(`[Firebase Config] ${reason}. Inizializzo Firestore standard (solo online).`);
    dbService = getFirestore(firebaseApp);
    internalPersistencePromise = Promise.resolve({ success: true, reason: reason });
}

// Esporta gli oggetti e la Promise per l'utilizzo in altri file
window.firebaseServices = {
    app: firebaseApp,
    auth: authService,
    db: dbService,
    analytics: analytics,
    persistenceSetupPromise: internalPersistencePromise,
};

console.log("[Firebase Config v1.14] Oggetto firebaseServices (con Analytics e fix Safari) creato ed esportato.");

// --- END OF FILE public/js/firebase/config.js ---